import { useContext } from 'react';

import { ThemeContext, type ThemeContextValue } from '@/theme/ThemeProvider';

export function useThemeMode(): ThemeContextValue {
  return useContext(ThemeContext);
}
